module.exports = __webpack_public_path__ + "img/index-section7-award2.24014741.png";